import React from "react"
import { connect } from "react-redux"
import { Link } from 'react-router-dom'
import NumberFormat from "react-number-format"

import moment from 'moment'
import { getProfile, getF2ListOrderDetail } from "../../model/profile"

// import { summaryTrips } from "../../actions/listF2Act"
import { commonErr } from "../common/errors"
import { getOrderStatus, ServiceType } from "../common/common"
import { LoadingPage } from "../common/loading"

import Header from "../common/header"
import Footer from "../common/footer"
import SideBar from "../common/sidebar"


class F2Performance extends React.Component {
	constructor() {
		super();
		this.state = {
			orders: []
		}
	}

	componentDidMount() {
		const { filter } = this.props.listF2;
		const f2UserId = this.props.match.params.f2UserId;

		this.getListOrdersDetail(f2UserId, filter)

		getProfile(f2UserId).then(resp => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.profile) { 
				this.setState({
					err: resp.data.error,
					profile: resp.data.data.profile
				})
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage
				})
			}
		})
		
	}

	getListOrdersDetail(f2UserId, filter) {

		this.setState({
				err: commonErr.LOADING
		});

		getF2ListOrderDetail(f2UserId, 0, 20, filter).then(resp => {
				if (resp.data.error >= commonErr.SUCCESS && resp.data.data.orders) {
						this.setState({
								err: resp.data.error,
								orders: resp.data.data.orders,
								more: resp.data.data.more
						});
				} else {
						this.setState({
								err: resp.data.error,
								orders: null,
								more: 0
						});
				}
		});
	}

	render() {
		
		let content; 
		const { err, orders, profile } = this.state;
		if (err === commonErr.INNIT || err === commonErr.LOADING) {
			content = <LoadingPage />
		} else if (err >= commonErr.SUCCESS && profile) {
	
		content = <div className="col-12">
			<div className="ibox">
					<div className="ibox-head">
						<div className="ibox-title">Đại lý {profile.name} </div>
					</div>
				<div className="ibox-body">
				<div class="table-responsive">
					<table className="table">
						<thead className="thead-default">
							<tr>
								<th>#</th>
								<th>Mã chuyến</th>
								<th>Dịch vụ</th>
								<th>Trạng thái</th>
								<th>Ngày đi </th>
								<th>Ngày về</th>
								{/* <th>Địa điểm</th> */}
								<th>Nhóm xe</th>
								<th>Giá trị chuyến sau KM</th>
							</tr>
						</thead>
						<tbody>
							{orders.length > 0 ? 
								orders.map((order, i) => {
									const status = getOrderStatus(order.status);

									return <React.Fragment key={i}>
										<tr>
											<td>{i + 1}</td>
											<td><Link className="link" to={{ pathname: `/trip/detail/${order.id}` }}>{order.id}</Link></td>
											<td>{ServiceType[order.serviceType]}</td>
											<td><span className={`badge badge-pill ${status.badge}`}>{status.name}</span></td>
											<td>{moment(order.tripDateFrom).format('DD/MM/YYYY')}</td>
											<td>{moment(order.tripDateTo).format('DD/MM/YYYY')}</td>
											<td>{order.carGroup !== null ? order.carGroup.groupName : ''}</td>
											<td><NumberFormat value={order.price} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>
										</tr>
									</React.Fragment>
								})
									
								: 
								<tr><td className="text-center p-4" colSpan="7">Chưa có chuyến nào</td></tr>
							}
						</tbody>
					</table>
					</div>
				</div>
				</div>
			</div>
		}

		return <div className="mioto-layout page-wrapper"	>
					<Header />
					<SideBar />
					<div className="content-wrapper">
						<div className="page-content fade-in-up">
							<div className="row">
								{content}
							</div>
						</div>
						<Footer />
					</div>
			</div>
	}
}

function mapState(state) {
	return {
		listF2: state.listF2
	}
}

F2Performance = connect(mapState)(F2Performance)

export default F2Performance


// WEBPACK FOOTER //
// ./src/components/dashboard/f2performance.js